<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="loadingItem">
            <b-spinner label="Text Centered" variant="primary"></b-spinner>
          </div>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.room"></strong>
          </div>
          <b-form @submit.prevent="save" v-show="!loadingItem">
            <b-form-group
              :label="$lang.name"
              label-for="name"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.name"
                :rules="$v.name.$params"
              />
              <b-form-input
                id="name"
                type="text"
                :autocomplete="$lang.name"
                :state="$v.name.$dirty ? !$v.name.$error : null"
                v-model="$v.name.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="name-feedback"
                >{{ $lang.error_required | replace($lang.name) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.capacity"
              label-for="capacity"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.capacity"
                :rules="$v.capacity.$params"
              />
              <b-form-input
                id="capacity"
                type="number"
                min="1"
                max="1000"
                :autocomplete="$lang.capacity"
                :state="$v.capacity.$dirty ? !$v.capacity.$error : null"
                v-model="$v.capacity.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="capacity-feedback"
                >{{ $lang.error_required | replace($lang.capacity) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.description"
              label-for="description"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.description"
                :rules="$v.description.$params"
              />
              <b-form-textarea
                id="description"
                v-model="$v.description.$model"
                :state="$v.description.$dirty ? !$v.description.$error : null"
                type="text"
                :autocomplete="$lang.description"
                rows="4"
              ></b-form-textarea>

              <b-form-invalid-feedback id="description-feedback"
                >{{ $lang.error_required | replace($lang.description) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";

export default {
  validations: {
    name: {
      required,
    },
    capacity: {
      required,
      numeric,
    },
    description: {},
  },
  name: "add-day_center_room",
  components: {},
  props: {
    entity: {
      type: String,
      default: "center_execute",
    },
    entityId: {
      type: String,
      default: "",
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loadingItem: false,
      name: "",
      capacity: "",
      description: "",
    };
  },
  methods: {
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.capacity = "";
      this.description = "";
    },
    changes() {},
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.loadingItem = true;
      let payload = {
        name: this.name,
        capacity: this.capacity,
        description: this.description,
      };
      this.$httpService
        .post(
          this.$config.api_url +
            this.$config.kanoon.center_execute_room.replace(
              "{0}",
              this.$route.params.id
            ),
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.afterSave();
        })
        .catch((err) => {
          this.loadingItem = false;

          this.$notify.error(err.response.data.message);
        });
    },
  },
  created() {
    // this.loadingItem = true;
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
